import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MaterialModule } from '@plugins/material/material.module'
import { RouterModule } from '@angular/router'
import { SharedModule } from '@shared/shared.module'
import { DashboardOverviewRoutingModule } from './dashboard-overview-routing.module'
import { DashboardOverviewComponent } from './components/dashboard-overview/dashboard-overview.component'
import { DashboardOverviewNgrxModule } from './dashboard-overview-ngrx.module'
import { ScopeUiTabComponent } from '@shared/components/ui-components/scope-ui-tab/scope-ui-tab.component'
import { ScopeUiTabsComponent } from '@shared/components/ui-components/scope-ui-tabs/scope-ui-tabs.component'
import { FinanceComponent } from './components/finance/finance.component'
import { ScopeUiPaginatorComponent } from '@shared/components/ui-components/scope-ui-paginator/scope-ui-paginator.component'

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    DashboardOverviewRoutingModule,
    DashboardOverviewNgrxModule,
    ScopeUiTabComponent,
    ScopeUiTabsComponent,
    ScopeUiPaginatorComponent,
  ],
  declarations: [DashboardOverviewComponent, FinanceComponent],
  providers: [],
  exports: [RouterModule],
})
export class DashboardOverviewModule {}
